import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IonicModule } from '@ionic/angular';

import { PaymentMethodPageRoutingModule } from './payment-method-routing.module';

import { PaymentMethodPage } from './payment-method.page';
import { MasterHeaderModule } from '../../master-header/master-header.module';
import { MasterFooterModule } from '../../master-footer/master-footer.module';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    PaymentMethodPageRoutingModule,
    MasterHeaderModule,
    MasterFooterModule,
  ],
  declarations: [PaymentMethodPage],
})
export class PaymentMethodPageModule {}
